import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import { FormikInput } from '../../../components';

export default function TotalValues() {
  const { values } = useFormikContext();
  const currentSettlement = values.settlement;
  const totalDiscounts = values.settlement.settlementBalancesAttributes.reduce((acc, current) => {
    return acc + +current.amount;
  }, 0);
  const assetsAmount = currentSettlement?.totalAmount || 0;
  const totalToPay = assetsAmount - totalDiscounts;
  const parsedTotal = new Intl.NumberFormat('es-CL').format(totalToPay);
  return (
    <>
      <Row className="summary__balances_header">
        <Col md={6}>
          <strong>Total</strong>
        </Col>
        <Col className="col-1" />
        <Col md={4}>
          <strong>Monto</strong>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="">
          <strong>Total a Pagar</strong>
        </Col>
        <Col className="col-1" />
        <Col md={4} className="disabled_input--settlement">
          <FormikInput leftAddon="$" value={parsedTotal} disabled />
        </Col>
      </Row>
    </>
  );
}
